import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import tvImage from "../../../assets/images/tataplay-tv-image.png";
import logo from "../../../assets/images/logo-updated.png";
import bottomshape from "../../../assets/images/tataplay-bottom.png";
import { Link, useNavigate } from "react-router-dom";
import Axios from "axios";
import Captcha from "../Captcha/Captcha";
import BasicModal from "../../core/BaseComponents/Modal";
import { faShieldAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Signup = () => {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm({
    mode: 'onChange'
  });

  const [apiErrorResponse, setApiErrorResponse] = useState([]);
  const [isLinkDisabled, setIsLinkDisabled] = useState(true);
  const [apiSuccessResponse, setApiSuccessResponse] = useState("");
  const [counter, setCounter] = useState(0);
  const [popupOpen, setPopupOpen] = useState(false);

  useEffect(() => {
    if (counter > 0) {
      const timeout = setTimeout(() => {
        setCounter((prevCounter) => prevCounter - 1);
      }, 1000);
      return () => {
        clearTimeout(timeout);
      };
    } else {
      setIsLinkDisabled(false);
      setApiErrorResponse("");
      setApiSuccessResponse("");
    }
  }, [counter]);

  const onSubmit = (data) => {
    Axios.post(`${process.env.REACT_APP_BASE_URL}/user/signup`, data, {
      withCredentials: true,
    })
      .then((response) => {
        setApiSuccessResponse(response?.data?.message);
        setApiErrorResponse("");
        setPopupOpen(true);
      })
      .catch((error) => {
        setApiErrorResponse(error.response?.data?.errorMessage);
        setApiSuccessResponse("");
      });
  };

  const handleMfaRequest = () => {
    setApiErrorResponse("");
    setApiSuccessResponse("");
    const payload = {
      username: watch("userName"),
      firstName: watch("firstName"),
      captchaText: watch("captchaText")
    };
    setCounter(30);
    setIsLinkDisabled(true);
    Axios.post(`${process.env.REACT_APP_BASE_URL}/user/signup-mfa`, payload, {
      withCredentials: true,
    })
      .then((response) => {
        setApiErrorResponse("");
        setApiSuccessResponse(response.data?.message);
      })
      .catch((error) => {
        setApiSuccessResponse("");
        setApiErrorResponse(error.response?.data?.errors);
      });
  };

  const popupCloseHandler = () => {
    setPopupOpen(false);
    navigate("/login");
  };

  return (
    <div className="login-container row">
      <div className="left-panel col-6">
        <div className="left-panel-tv-logo">
          <img src={tvImage} alt="left pannel setup box" />
        </div>
        <div className="left-panel-logo">
          <img src={logo} alt="login logo" />
        </div>
        <div className="left-panel-shape">
          <img src={bottomshape} alt="login bottom shape" />
        </div>
      </div>
      <div className="right-panel col-6">
        <div className="form-wrapper">
          <h2>Create Account</h2>
          <p className="login-title">
            Enter details to register your account to have an <br/>access for HMS.
          </p>
          <p className="login-success">{apiSuccessResponse}</p>
          <p className="login-error">{apiErrorResponse}</p>
          <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div className="row">
              <div className="form-group col-6">
                <label htmlFor="firstName">First Name</label>
                <input
                  id="firstName"
                  placeholder="Enter First Name"
                  className="form-control"
                  maxLength={30}
                  {...register("firstName", {
                    required: "Please Enter Your First Name",
                    pattern: {
                      value: /^[a-zA-Z]+$/,
                      message: "Only Alphabets allowed",
                    },
                  })}
                />
                {errors.firstName && (
                  <small className="error">{errors.firstName.message}</small>
                )}
              </div>
              <div className="form-group col-6">
                <label htmlFor="lastName">Last Name</label>
                <input
                  id="lastName"
                  className="form-control"
                  maxLength={30}
                  placeholder="Enter Last Name"
                  {...register("lastName", {
                    required: "Please Enter Your Last Name",
                    pattern: {
                      value: /^[a-zA-Z. ]+$/,
                      message: "Only Alphabets, dot & blank space allowed",
                    },
                  })}
                />
                {errors.lastName && (
                  <small className="error">{errors.lastName.message}</small>
                )}
              </div>
              <div className="form-group col-6">
                <label htmlFor="userName">Email</label>
                <input
                  id="userName"
                  className="form-control"
                  placeholder="Enter Email"
                  maxLength={60}
                  {...register("userName", {
                    required: "Please Enter Your Email",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter Email in Correct format",
                    },
                  })}
                />
                {errors.userName && (
                  <small className="error">{errors.userName.message}</small>
                )}
              </div>
              <div className="form-group col-6">
                <label htmlFor="phoneNo">Phone Number</label>
                <input
                  id="phoneNo"
                  className="form-control"
                  placeholder="Enter Phone Number"
                  // maxLength={12}
                  // minLength={10}
                  {...register("phoneNo", {
                    required: "Please Enter Phone Number",
                    pattern: {
                      value: /^[0-9]{10,12}$/,
                      message: "Phone number must be between 10 and 12 digits",
                    },
                  })}
                />
                {errors.phoneNo && (
                  <small className="error">{errors.phoneNo.message}</small>
                )}
              </div>
              <div className="form-group col-6">
                <label htmlFor="captchaText">Captcha Text</label>
                <input
                  id="captchaText"
                  className="form-control"
                  maxLength={8}
                   placeholder="Enter Captcha Code"
                  {...register("captchaText", {
                    required: "Please Enter Captcha Code",
                  })}
                />
                {errors.captchaText && (
                  <small className="error">{errors.captchaText.message}</small>
                )}
              </div>
              <div className="form-group col-6 position-relative">
              <FontAwesomeIcon icon={faShieldAlt} className="signup-icons" />
                <label htmlFor="mfaCode">MFA Code</label>
                <input
                  id="mfaCode"
                  className="form-control"
                  placeholder="Enter MFA Code"
                  maxLength={8}
                  {...register("mfaCode", { required: "Please Enter MFA Code" })}
                />
                {errors.mfaCode && (
                  <small className="error">{errors.mfaCode.message}</small>
                )}
              </div>
              <div className="form-group col-6">
                <Captcha />
              </div>
              <div className="form-group col-6 text-end">
                <button
                  type="button"
                  className={`mfa-btn ${( !watch("userName") || !watch("captchaText") || !watch("firstName") || errors.userName?.message || errors.firstName?.message)? "inactive-mfa" : "active-mfa"}`}
                  onClick={handleMfaRequest}
                  disabled={
                    isLinkDisabled || !watch("userName") || !watch("captchaText") || !watch("firstName") || errors.userName?.message || errors.firstName?.message
                  }
                >
                  {isLinkDisabled
                    ? `Resend MFA Code In ${counter} sec`
                    : "Send MFA Code"}
                </button>
              </div>
            </div>
            <div className=" col-7 mx-auto">
              <button type="submit" className="login-btn">
                Sign Up
              </button>
            </div>
          </form>

          <div className="col-8 create-account">
              <Link to="/login">
              Already have an account? Login
              </Link>
            </div>

        </div>
      </div>
      <BasicModal
        popupOpen={popupOpen}
        bodyMessage={apiSuccessResponse}
        footer={{
          secondaryButton: {
            action: popupCloseHandler,
            buttonName: "OK",
          },
        }}
      />
    </div>
  );
};

export default Signup;
